module.exports = __webpack_public_path__ + "media/images/logo-black-small-2f9da7096863a2609783c555cb5e448f.png";